/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'contactPage',
	title: 'Contact Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Page Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'header',
			title: 'Header Section',
			type: 'pageHeader',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'contactFormTitle',
			title: 'Contact Form Title',
			type: 'string',
			initialValue: 'Get in touch',
		},
		{
			name: 'contactFormDescription',
			title: 'Contact Form Description',
			type: 'text',
		},
		{
			name: 'contactDetails',
			title: 'Contact Details',
			type: 'object',
			fields: [
				{
					name: 'email',
					title: 'Email',
					type: 'string',
				},
				{
					name: 'phone',
					title: 'Phone',
					type: 'string',
				},
				{
					name: 'officeHours',
					title: 'Office Hours',
					type: 'array',
					of: [{ type: 'string' }],
				},
			],
		},
		{
			name: 'seo',
			title: 'SEO Settings',
			type: 'object',
			fields: [
				{
					name: 'metaTitle',
					title: 'Meta Title',
					type: 'string',
				},
				{
					name: 'metaDescription',
					title: 'Meta Description',
					type: 'text',
				},
			],
		},
	],
	preview: {
		select: {
			title: 'title',
		},
	},
};
